// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"65":"b70dfb167ec81147","185":"b8b101c28a9c9c48"}[chunkId] + ".css";
};